<template>
  <div class="site-bottom" :class="{'page-bottom': is_fixed}">
    <div class='home_content' v-if="show_bottom_content">
      <div class='home_title'>
        <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
        <p>JOIN Play2Ever</p>
      </div>
      <div class="msg_content">
        <el-image :src="grande_join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>
      </div>
    </div>
    <div :class="bottomClass" v-if="is_pc">
      <img
        :src="logoSrc"
        alt="Logo"
        style="height: 3vw; margin-top: 0.5vw"
      />
      <div class="cbr-contact" v-if="isCbr">
        <p class="cbr-contact-label">Support</p>
        <a class="cbr-contact-mail" :href="'mailto:' + cbrSupportEmail">
          <span class="cbr-mail-blocks" aria-hidden="true">
            <i></i><i></i><i></i><i></i>
          </span>
          {{ cbrSupportEmail }}
        </a>
      </div>
      <div class="bottom-links">
        <a
          :href="privacyPolicyUrl"
          target="_blank"
          rel="noopener noreferrer"
        >Privacy Policy</a>
        <span class="bottom-links-divider">|</span>
        <a
          :href="termsOfServiceUrl"
          target="_blank"
          rel="noopener noreferrer"
        >Terms of Service</a>
      </div>
    </div>
  </div>

</template>


<script>
import { getLogoSrc, isColorBlockRun } from "../utils/logo";

export default {
  data() {
    return {
      grande_join_bottom:`${require('../assets/img_spin/joinus_v2.png')}`,
      input: ''
    };
  },
  computed: {
    is_pc() {
      return document.documentElement.clientWidth > 992;
    },
    //英文版首页、关于页，内容不足
    is_fixed() {
      const cur_path = this.$route.path.split('/')[1];
      return false;
      // return cur_path === '' && this.$i18n.locale === 'en' ? true : false
    },
    join_bottom() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc.png';
    },
    join_bottom_en() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc_en.png';
    },
    isBole() {
      return /bole|localhost/.test(window.location.hostname)
    },
    show_bottom_content() {
      return !isColorBlockRun();
    },
    logoSrc() {
      return getLogoSrc();
    },
    bottomClass() {
      return isColorBlockRun() ? 'cbr-bottom' : 'new-bottom';
    },
    isCbr() {
      return isColorBlockRun();
    },
    cbrSupportEmail() {
      return 'colorblockrun-support@play2ever.com';
    },
    privacyPolicyUrl() {
      return isColorBlockRun()
        ? 'https://play2ever-policy.com/color-block-run/view#play2ever-privacy-policy'
        : 'https://play2ever-policy.com/play2ever-legal-center/view#play2ever-privacy-policy';
    },
    termsOfServiceUrl() {
      return isColorBlockRun()
        ? 'https://play2ever-policy.com/color-block-run/view#color-block-run-terms-of-service'
        : 'https://play2ever-policy.com/play2ever-legal-center/view#play2ever-terms-of-service';
    },
  }
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');
.beian {
  font-size: 1.2vw;
  color: white;
  padding-bottom: 20px;
  font-family: auto;
  cursor: pointer;
  a {
    text-decoration:none;
    color: #828181;
  }
}
#bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 0 1vw;
  background: @lanmu;
  position: relative;
}
.bottom-img {
  width: 70%
}
.msg_content {
  width: 100%;
  // padding: 2.5vw 2.2vw;
  // background: @lanmu;
  position: relative;
  overflow: hidden;
  .msg {
    width: 24vw;
    height: 3.5vw;
    margin-top: 1vw;
    background: white;
    display: flex;
    float: right;
    align-items: center;
    overflow: hidden;
    .msg-input {
      position: relative;
      width: 79%;
      float: left;
    }
    .msg-icon {
      float: right;
      margin-right: 1px;
    }
  }
  .msg_content_intro {
    position: relative;
    float: left;
    width: 50%;
    .msg-text {
      width: 70%;
    }
  }
}
.msg-input {
  display: block;
}
.msg-input-mobile {
  display: none;
}
.over {
  overflow:hidden;
}
.msg-icon-img {
  height: 3vw;
  margin-top: 5px;
}
.anti-fraud {
  position: absolute;
  left: 70%;
  top: 0;
  width: 26%;
  text-align: left;
  color: #b9b2e2;
  font-weight: 500;
}
.anti-fraud-i {
  font-style: italic;
  font-size: 13px;
}

@media screen and (max-width: 992px) {
  .anti-fraud {
    font-size: 12px;
    position: relative;
    text-align: center;
    left: 0%;
    width: 100%;
    transform: scale(0.7);
  }
  .beian {
    font-size: 12px;
    padding-bottom:2px;
  }
  .home_title p {
    bottom: 2.3vw;
  }
  .home-title-icon {
    height: 6.5vw;
  }
  .msg_content {
    .msg {
      width: 50%;
      height: 5.5vw;
      margin-top: -1vw;
      margin-top: 3vw;
    }
    .msg_content_intro {
      width: 45%;
      .msg-text {
        width: 85%;
      }
    }
  }
  .msg-input {
    display: none;
  }
  .msg-input-mobile {
    display: block;
  }
  .msg-icon-img {
    height: 5vw;
  }
  .bottom-img {
    width: 90%
  }
  .page-bottom {
    bottom: 0;
    margin-top: 3vw;
    position: fixed;
  }
}
.site-bottom {
  width: 100%;
  margin-top: auto;
  flex-shrink: 0;
}
.new-bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 22vw;
  background: @lanmu;
  position: relative;
  box-sizing: border-box;
  td {
    line-height: 12px;
  }
}
.cbr-bottom {
  width: 100%;
  padding: 2vw 22vw 2.4vw;
  position: relative;
  box-sizing: border-box;
  td {
    line-height: 12px;
  }
  .cbr-contact {
    margin: 1vw auto 0.2vw;
  }
  .cbr-contact-label {
    margin: 0 0 0.55vw;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    color: rgba(236, 230, 214, 0.52);
  }
  .cbr-contact-mail {
    display: inline-flex;
    align-items: center;
    gap: 0.7em;
    padding: 0.52em 1.15em 0.52em 0.72em;
    color: #2c2416;
    background: #f4ead0;
    border-radius: 999px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.015em;
    box-shadow: 0 3px 0 rgba(18, 10, 32, 0.28);
    transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
    &:hover {
      transform: translateY(-2px);
      background: #fff6df;
      box-shadow: 0 5px 0 rgba(18, 10, 32, 0.28);
    }
  }
  .cbr-mail-blocks {
    display: inline-flex;
    gap: 3px;
    i {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 2px;
      &:nth-child(1) { background: #ff5b6b; }
      &:nth-child(2) { background: #ffd24a; }
      &:nth-child(3) { background: #7adf5a; }
      &:nth-child(4) { background: #4ec8ff; }
    }
  }
}
.bottom-links {
  margin-top: 1vw;
  a {
    color: #c9c6db;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    &:hover {
      color: #f3c258;
    }
  }
}
.bottom-links-divider {
  margin: 0 12px;
  color: #8c8b9a;
}
.copyright {
  color: #8a8a90;
  font-weight: 800;
  font-size: 14px;
  font-family: fangsong;
}
.contact-info {
  color: #fff6c1;
  font-weight: 800;
  font-size: 16px;
  font-family: fangsong;
  margin-bottom: 10px;
}
.location-text {
  color: #bdbad6;
  font-weight: 800;
  font-size: 14px;
  font-family: fangsong;
  line-height: 14px;
}
.icon-td {
  width: 30px;
}
.anti {
  color: #bdbad6;
  font-weight: 500;
  font-size: 14px;
  font-family: fangsong;
  line-height: 14px;
  margin-top: 10px;
  width: 300px;
  text-align: right;
}
</style>





// WEBPACK FOOTER //
// src/components/Bottom.vue